module.exports = __webpack_public_path__ + "static/media/carita.b4291f90.png";